import {
  OptionContent,
} from "@babackapp/customer-ui/components/option";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@babackapp/customer-ui/components/select";
import { Suspense } from "react";
import {
  getUniqueValues,
  isValueAvailable,
  useVariantSelector,
} from "../../hooks/use-variant-selector";

type VariantFooterProps = {
  orderId: string;
  lineItemId: string;
  shopId: string;
  onVariantChange: (variantId: string | null) => void;
};

function VariantFooterInner({ orderId, lineItemId, shopId, onVariantChange }: VariantFooterProps) {
  const {
    products,
    selectedProductId,
    selectedOptions,
    selectedProduct,
    selectableOptions,
    hasRealChoice,
    minimalStock,
    handleProductChange,
    handleOptionChange,
  } = useVariantSelector(orderId, lineItemId, shopId, onVariantChange);

  if (!hasRealChoice) return null;

  return (
    <OptionContent className="flex-wrap">
      {products.length > 1 && (
        <Select value={selectedProductId} onValueChange={handleProductChange}>
          <SelectTrigger className="w-auto">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {products.map((p) => (
              <SelectItem key={p.productId} value={p.productId}>
                {p.productTitle}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
      {selectableOptions.map((opt) => {
        const values = getUniqueValues(selectedProduct?.variants ?? [], opt.name).filter(
          (v) => v !== "Default Title",
        );
        return (
          <Select
            key={opt.name}
            value={selectedOptions[opt.name] ?? ""}
            onValueChange={(v) => handleOptionChange(opt.name, v)}
          >
            <SelectTrigger className="w-auto">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {values.map((v) => {
                const available = isValueAvailable(
                  selectedProduct?.variants ?? [],
                  selectedOptions,
                  opt.name,
                  v,
                  minimalStock,
                );
                return (
                  <SelectItem key={v} value={v} disabled={!available}>
                    {v}
                    {!available ? " (indisponible)" : ""}
                  </SelectItem>
                );
              })}
            </SelectContent>
          </Select>
        );
      })}
    </OptionContent>
  );
}

export function VariantFooter(props: VariantFooterProps) {
  return (
    <Suspense fallback={null}>
      <VariantFooterInner {...props} />
    </Suspense>
  );
}
